import { AbstractControl, ValidatorFn } from '@angular/forms';
import * as moment from 'moment';

export const isDateValid = (year: string = 'year', month: string = 'month', day: string = 'day'): ValidatorFn =>
    (control: AbstractControl) => {
        const dayControl: AbstractControl = control?.parent?.controls[day];
        const monthControl: AbstractControl = control?.parent?.controls[month];
        const yearControl: AbstractControl = control?.parent?.controls[year];

        if (!dayControl
            || !dayControl.dirty
            || !monthControl
            || !monthControl.dirty
            || !yearControl
            || !yearControl.dirty
        ) return null;
        const d: string = `${yearControl.value}-${monthControl.value.length > 1 ? monthControl.value : 0 + monthControl.value}-${dayControl.value.length > 1 ? dayControl.value : 0 + dayControl.value}T12:00:00.000Z`;

        return moment(d, moment.ISO_8601, true).isValid() ?
            null :
            {
                'dateOfBirth': 'Date of birth is invalid'
            };
    };
